import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { AuthService } from '../services/auth.service';

/**
 * Redirects `/clients/:wrongClientId/…` into the JWT active client's canonical URL (`/clients/{active}/…`).
 */
export const activeClientParamGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const aid = auth.clientId();
  if (!aid) {
    return router.parseUrl('/login');
  }
  const m = /^\/clients\/([^/]+)(.*)$/.exec(state.url.split('?')[0] ?? '');
  if (!m) {
    return true;
  }
  const [, urlClient, rest] = m;
  if (urlClient === aid) {
    return true;
  }
  return router.parseUrl(`/clients/${aid}${rest || '/'}`);
};
